import React from 'react';
import wb0 from '../img/Detail/curio-detail.jpg';
import './Detail.css';
const CurioDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default CurioDetail;